import React from 'react';
import { Table, Button } from 'antd/lib';
import _ from 'lodash';

export default ({ pares, removerPar }) => {
  const columns = [
    {
      title: 'Organismo',
      dataIndex: ['organismo', 'nombre'],
      sortOrder: true,
    },
    {
      title: 'Talonario',
      dataIndex: ['talonario', 'nombre'],
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (text, record) => (
        <span>
          <Button
            type="danger"
            onClick={() => removerPar(record.organismo._id)}
          >
            Eliminar
          </Button>
        </span>
      ),
    },
  ];
  let listaOrdenada = _.orderBy(pares, [par => par.organismo.nombre], ['asc']);
  return (
    <Table pagination={false} columns={columns} dataSource={listaOrdenada} />
  );
};
